/* istanbul ignore file */
import React from 'react';
import { Button, ButtonColor, ButtonSize, FormButtonLayoutProps } from 'ui-builder';
import useFeatureToggleService from 'feature-toggle';
import ShadcnSubmitButtonLayout from './ShadcnSubmitButtonLayout';

function LegacySubmitButtonLayout(props: FormButtonLayoutProps) {
  return (
    <Button
      isFilled={props.isFilled}
      text={props.text}
      size={props.size || ButtonSize.BIG}
      color={props.color || ButtonColor.GREEN}
      iconType={props.iconType}
      onClick={props.onClick}
      testId={props.testId}
      isDisabled={props.isDisabled}
      isSubmitButton
    />
  );
}

function SubmitButtonLayout(props: FormButtonLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnSubmitButtonLayout {...props} />;
  } else {
    return <LegacySubmitButtonLayout {...props} />;
  }
}

export default SubmitButtonLayout;
